import React from 'react';
import Select from 'react-select';

export default function YearSelect({ year, years, onChange, menuPortalTarget, styles }) {
  const modifyYears = (years) => years.map((val) => ({ value: val, label: val }));
  return (
    <Select
      placeholder="Выберите год"
      defaultValue={[{ value: year || new Date().getFullYear(), label: year || new Date().getFullYear() }]}
      name="yearsSingle"
      options={modifyYears(years)}
      onChange={onChange}
      value={year ? { value: year, label: year } : null}
      isSearchable={false}
      menuPortalTarget={menuPortalTarget}
      styles={styles}
    />
  );
}
